import React, { useMemo } from 'react';
import { Field, FormSection } from 'redux-form';
import { MarketingCheckbox } from './components';
import { Box } from '../../../../common/components';
import { Row, Col, FormGroup, ControlLabel } from 'react-bootstrap';
import MdEmail from 'react-icons/lib/md/email';
import MdPhoneIphone from 'react-icons/lib/md/phone-iphone';
import MdLaptopMac from 'react-icons/lib/md/laptop-mac';
import MdPhone from 'react-icons/lib/md/phone';

import './Marketing.scss';

const ICON_SIZE = 15;
const LABEL_SIZE = 8;

const EMAIL = [{ label: 'Email', value: 1, valid: [1, 2] }];
const SMS = [{ label: 'SMS', value: 1, valid: [1, 2] }];
const POST = [{ label: 'Post', value: 1, valid: [1, 2] }];
const PHONE = [{ label: 'Phone', value: 1, valid: [1, 2] }];

const SelectAllCheckbox = ({
  options,
  inline,
  isChecked,
  onToggleSelectAll,
  labelSize,
}) => {
  const toggleSelectAll = () => {
    onToggleSelectAll(!isChecked);
  };

  return (
    <FormGroup>
      <Col sm={labelSize}>
        <ControlLabel className={inline ? ' inline-radio-label' : ''}>
          Select all
        </ControlLabel>{' '}
      </Col>

      <Col sm={4} className={'radio-group'}>
        {options.map((option, key) => {
          return (
            <div className={'radio-container' + (inline ? ' inline' : '')} key={key}>
              <div className="marketing-checkbox">
                <input
                  type="checkbox"
                  id={'select-all-chbx'}
                  value={option.value}
                  checked={isChecked}
                />
                <label htmlFor={'select-all-chbx'} onClick={toggleSelectAll} />
              </div>
            </div>
          );
        })}
      </Col>
    </FormGroup>
  );
};

const areAllSelected = (marketingOptions) => {
  const marketingValues = Object.values(marketingOptions);

  return marketingValues?.reduce((carry, value) => {
    return carry && value > 0;
  }, true);
};
const IssuePolicyMarketing = ({ input }) => {
  const marketingOptions = input.value;

  const isAllSelected = useMemo(() => areAllSelected(marketingOptions), [
    marketingOptions,
  ]);

  const toggleSelectAllMarketing = (value) => {
    const newValue = value ? 1 : -1;

    const newMarketing = {
      phone: newValue,
      sms: newValue,
      email: newValue,
      post: newValue,
    };
    input.onChange(newMarketing);
  };

  return (
    <div>
      <div className="marketing-ip">
        <Box>
          <Row>
            <Col sm={12}>
              <p>
                We’d like to keep in touch and send you details of special offers that can
                be used on future policies and related products, as well as updates on the
                latest travel news that may affect your plans.{' '}
              </p>

              <Row className={'issue-policy-marketing'}>
                <FormSection name={input.name}>
                  <Col sm={2}>
                    <SelectAllCheckbox
                      options={[{ label: 'All', value: true }]}
                      onToggleSelectAll={toggleSelectAllMarketing}
                      isChecked={isAllSelected}
                      labelSize={LABEL_SIZE}
                      label="Select All"
                    />
                  </Col>
                  <Col sm={2}>
                    <Field
                      name={'post'}
                      options={POST}
                      component={MarketingCheckbox}
                      format={consentToBool()}
                      normalize={consentToInt()}
                      labelSize={LABEL_SIZE}
                      label={
                        <div>
                          <MdEmail size={ICON_SIZE} />
                          <span> Post</span>
                        </div>
                      }
                    />
                  </Col>
                  <Col sm={2}>
                    <Field
                      name={'email'}
                      options={EMAIL}
                      component={MarketingCheckbox}
                      format={consentToBool()}
                      normalize={consentToInt()}
                      labelSize={LABEL_SIZE}
                      label={
                        <div>
                          <MdLaptopMac size={ICON_SIZE} />
                          <span> Email</span>
                        </div>
                      }
                    />
                  </Col>
                  <Col sm={2}>
                    <Field
                      name={'sms'}
                      options={SMS}
                      component={MarketingCheckbox}
                      format={consentToBool()}
                      normalize={consentToInt()}
                      labelSize={LABEL_SIZE}
                      label={
                        <div>
                          <MdPhoneIphone size={ICON_SIZE} />
                          <span> SMS</span>
                        </div>
                      }
                    />
                  </Col>
                  <Col sm={2}>
                    <Field
                      name={'phone'}
                      options={PHONE}
                      component={MarketingCheckbox}
                      format={consentToBool()}
                      normalize={consentToInt()}
                      labelSize={LABEL_SIZE}
                      label={
                        <div>
                          <MdPhone size={ICON_SIZE} />
                          <span> Phone</span>
                        </div>
                      }
                    />
                  </Col>
                </FormSection>
              </Row>
            </Col>
          </Row>
        </Box>
      </div>
    </div>
  );
};

export default IssuePolicyMarketing;

const consentToInt = () => {
  return (v) => (v ? 1 : -1);
};
const consentToBool = () => {
  return (v) => v === 1 || v === 2;
};
